import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { Staff } from '../models/staff';
import { StaffDialogComponent } from './dialogs/staff-dialog/staff-dialog.component';
import { StaffService } from '../services/staff.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';

import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss'],
  entryComponents: [
    StaffDialogComponent
  ]
})
export class StaffComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['icon', 'title', 'name', 'state', 'country','edit', 'delete'];

  constructor(
    private _staffService: StaffService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    private router: Router
  ) {

    if (!this._authService.isAdmin) {
      this.router.navigate(['home']);
    }

    this.loadStaffs()
  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadStaffs() {

    this.sub = this._staffService.select()
      .subscribe((result) => {
        let array = result.map(item => {
          let entity = new Staff();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.title = item.payload.doc.data().title;
          entity.email = item.payload.doc.data().email;
          entity.state = item.payload.doc.data().state;
          entity.country = item.payload.doc.data().country;
          return entity;
        });

        setTimeout(() => {
          this.dataSource = new MatTableDataSource(array);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(entity) {

    let data: Staff = new Staff();

    if (entity) {
      data = entity;
    }

    this.dialog.open(StaffDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  delete(element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '280px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.name + "<br><br>Excluir este apoiador?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._staffService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete room error: " + error.message) }
          )
      }
    })
  }

}
